import classNames from "classnames/dedupe";
import React, { ElementType, FC, ReactNode } from "react";

export interface IScrollContainerProps {
  /**
   * Set max-height of scrollable container
   */
  height?: number | "auto" | "100vh" | "100%";
  classes?: { root?: string };
  /**
   * Sets a custom html element for this component
   *
   * @default 'div'
   */
  as?: ElementType;
  children?: ReactNode;
}

const ScrollContainer: FC<IScrollContainerProps> = ({
  as: Component = "div",
  height,
  classes,
  children,
}) => {
  const rootClasses = classNames("uds-scroll", classes?.root);
  return (
    <Component className={rootClasses} style={{ maxHeight: height }}>
      {children}
    </Component>
  );
};

export default ScrollContainer;
